import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  item: {
    border: '1px black solid',
    padding: theme.spacing(1),
    margin: theme.spacing(2),
    width: 200,
    display: 'inline-block',
    textAlign: 'center',

    '& i.fa': {
      marginRight: theme.spacing(2)
    }
  }
}))

export {
  useStyles
}